import styled from 'styled-components';

const MenuTag = styled.div`
  background: #dddddd;
  border-radius: 4px;
  margin-left: 8px;
  font-family: 'Basier Circle';
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 10px;
  letter-spacing: -0.10000000149011612px;
  text-align: center;
  color: #797979;
  padding: 4px 5px 4px 5px;
`;

export default MenuTag;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/MenuTag/index.jsx